import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col px-2 py-1 hover:bg-gray-100" }
const _hoisted_2 = { class: "flex gap-2 items-center" }
const _hoisted_3 = { class: "truncate" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-gray-500 truncate"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_6 = { class: "text-gray-600 text-xs lowercase truncate" }
const _hoisted_7 = {
  key: 0,
  class: "text-gray-400 text-xs"
}

import { ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";
import { format } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useHasPermission } from "shared/composables/project";
import { Organization } from "shared/types/Organization";
import { Project } from "shared/types/Project";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTabProjectsItem',
  props: {
    organization: {},
    project: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const hasAdminPermission = useHasPermission("app_admin");

const address = computed(() =>
  [props.project.street, props.project.zip_code, props.project.country_code]
    .filter((item) => item)
    .join(", "),
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.project.name), 1),
      (_unref(hasAdminPermission))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.project.customer_name) + "/" + _toDisplayString(_ctx.project.site_id), 1))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(format)(_ctx.project.planned_start, "dd.MM.yyyy")) + " " + _toDisplayString(_ctx.project.planned_end
            ? `- ${_unref(format)(_ctx.project.planned_end, "dd.MM.yyyy")}`
            : `- ${_ctx.$t("calendar.today")}`), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["px-3 py-0.5 text-center rounded-md text-xs text-white truncate", [_ctx.project.status === 'active' ? 'bg-green-500' : 'bg-gray']])
      }, _toDisplayString(_unref(t)(`admin.general_project_settings.project_status.${_ctx.project.status}`)), 3),
      _createVNode(_component_RouterLink, {
        to: {
          name: 'ProjectOverview',
          params: { customer_name: _ctx.project.customer_name, site_id: _ctx.project.site_id },
        },
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "w-5 h-5" })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (address.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(address.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})